<div class="tab-container mt-4">
  <lib-button
    [cssType]="'btn-secondary'"
    [text]="'Add Admin User'"
    [size]="'small'"
    (click)="addWholesaler()"
  ></lib-button>
  <lib-ui-grid [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>
</div>
